// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// //images
// import img1 from "../AboutUsPage/images/aanad sir.jpg";
// import img2 from "../AboutUsPage/images/sazal sir.jpg";
// import img3 from "../AboutUsPage/images/pitamber sir.jpg";
// import img4 from "../AboutUsPage/images/kanchan.png";
// import img5 from "../AboutUsPage/images/paswan sir.jpg";
// import img6 from "../AboutUsPage/images/Amit1.jpg";
// import img7 from "../AboutUsPage/images/neha.png";
// import img8 from "../AboutUsPage/images/Lucky.png";
// import img9 from "../AboutUsPage/images/Rojalin.png";

// import { FaTwitter, FaLinkedinIn } from "react-icons/fa";

// const data = [
//     {
//         image: img1,
//         name: "Shailendra Anand",
//         position: "(Founder)",
//         desc:
//             "As Founder, spearheading the design of scalable systems to streamline customer data management, enabling high lead conversion and sustained client relationships.",
//     },
//     {
//         image: img2,
//         name: "Sazal Malhotra",
//         position: "(Co-Founder)",
//         desc:
//             "As Co-Founder, driving the vision and development of AI-powered no-code chatbot solutions to transform customer engagement and accelerate business growth.",
//     },
//     {
//         image: img3,
//         name: "Pitamber Sarway",
//         position: "(Fullstack Developer)",
//         desc:
//             "Engineering end-to-end web solutions with seamless frontend, backend, and API integration to strengthen brand trust and maximize user engagement.",
//     },
//     {
//         image: img4,
//         name: "Kanchan Adil",
//         position: "(Business Analyst)",
//         desc:
//             "Analyzing data-driven strategies to maximize customer reach through broadcasting and boost conversions with targeted retargeting insights.",
//     },
//     {
//         image: img5,
//         name: "Ravindra Pasvan",
//         position: "(Frontend Developer)",
//         desc:
//             "Designing responsive user interfaces and integrating backend functionality to deliver seamless digital experiences and measurable business impact.",
//     },
//     {
//         image: img6,
//         name: "Amit Banjare",
//         position: "(Fullstack Developer)",
//         desc:
//             "Developing robust fullstack applications with a strong focus on secure backend architecture, API integration, and compliant data storage.",
//     },
//     {
//         image: img7,
//         name: "Neha Nand",
//         position: "(Graphics Designer)",
//         desc:
//             "Designing impactful visuals and creatives that enhance brand communication, streamline customer interaction, and elevate business presence across platforms.",
//     },
//     {
//         image: img8,
//         name: "Lekheshwar Das",
//         position: "(Fullstack Developer)",
//         desc:
//             "Developing robust frontend and backend systems with efficient API handling to enable large-scale broadcasts and precise customer retargeting.",
//     },
//     {
//         image: img9,
//         name: "Rojalin Behera",
//         position: "(Frontend Developer)",
//         desc:
//             "Creating dynamic user interfaces and integrating backend functionalities to scale customer engagement via broadcast and retargeting.",
//     },
// ];

// const Ourteam = () => {
//     return (
//         <section className="py-4 position-relative" style={{ overflow: "hidden" }}>
//             <div
//                 className="px-3 px-md-4 mx-auto position-relative"
//                 style={{ maxWidth: "72%", zIndex: 1 }}
//             >
//                 {/* Heading */}
//                 <div style={{ marginTop: "80px" }}>
//                     <h2
//                         style={{
//                             fontSize: "44px",
//                             fontFamily: "'Inter', sans-serif",
//                             fontWeight: 650,
//                             color: "#1C1C1C",
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         Our Team
//                     </h2>
//                     <p
//                         className="mt-2"
//                         style={{
//                             fontSize: "20px",
//                             color: "#6B6B6B",
//                             fontWeight: 400,
//                             fontFamily: "'Inter', sans-serif",
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         We are a passionate team of developers, designers, analysts and
//                         marketers-turning bold ideas into impactful, scalable digital
//                         solutions that drive growth and shape the future.
//                     </p>
//                 </div>

//                 {/* Auto left-scroll row with added top space */}
//                 <TeamMarquee items={data} />
//             </div>
//         </section>
//     );
// };

// const TeamMarquee = ({ items }) => {
//     // Fixed card dimensions for consistent animation
//     const CARD_W = 300;
//     const CARD_GAP = 28;
//     const SPEED_SEC = 30; // Slower speed for better viewing

//     // Calculate total width of one complete set
//     const totalWidth = (CARD_W + CARD_GAP) * items.length - CARD_GAP;

//     return (
//         <>
//             <div className="tm-viewport">
//                 <div className="tm-track" aria-label="Team members carousel">
//                     {/* Render original items */}
//                     {items.map((member, index) => (
//                         <article
//                             key={`original-${index}`}
//                             className="tm-card"
//                         >
//                             <div className="tm-avatar-wrap">
//                                 <img src={member.image} alt={member.name} className="tm-avatar" />
//                             </div>
//                             <div className="tm-name">{member.name}</div>
//                             <div className="tm-role">{member.position}</div>
//                             <div className="tm-desc">{member.desc}</div>
//                             {/*  Social icons */}
//                             <div className="tm-social">
//                                 <div className="tm-social-icon"><FaTwitter /></div>
//                                 <div className="tm-social-icon"><FaLinkedinIn /></div>
//                             </div>
//                         </article>
//                     ))}

//                     {/* Render duplicate items for seamless loop */}
//                     {items.map((member, index) => (
//                         <article
//                             key={`duplicate-${index}`}
//                             className="tm-card"
//                             aria-hidden="true"
//                         >
//                             <div className="tm-avatar-wrap">
//                                 <img src={member.image} alt={member.name} className="tm-avatar" />
//                             </div>
//                             <div className="tm-name">{member.name}</div>
//                             <div className="tm-role">{member.position}</div>
//                             <div className="tm-desc">{member.desc}</div>
//                             {/* Social icons exactly  */}
//                             <div className="tm-social">
//                                 <div className="tm-social-icon"><FaTwitter /></div>
//                                 <div className="tm-social-icon"><FaLinkedinIn /></div>
//                             </div>
//                         </article>
//                     ))}
//                 </div>
//             </div>
//             <style>{`
//         .tm-viewport {
//           position: relative;
//           overflow: hidden;
//           width: 100%;
//           margin-top: 60px;
//           -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
//                   mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
//         }

//         .tm-track {
//           display: flex;
//           gap: ${CARD_GAP}px;
//           align-items: stretch;
//           will-change: transform;
//           animation: tm-scroll ${SPEED_SEC}s linear infinite;
//         }

//         .tm-viewport:hover .tm-track {
//           animation-play-state: paused;
//         }

//         /* Perfect seamless loop animation */
//         @keyframes tm-scroll {
//           from {
//             transform: translateX(0);
//           }
//           to {
//             transform: translateX(-${totalWidth}px);
//           }
//         }

//         /* ====== Glassmorphism card ====== */
//         // .tm-card {
//         //   flex: 0 0 ${CARD_W}px;
//         //   width: ${CARD_W}px;
//         //   height: 450px;
//         //   border-radius: 16px;
//         //   background: rgba(255,255,255,0.55);
//         //   backdrop-filter: blur(14px) saturate(140%);
//         //   -webkit-backdrop-filter: blur(14px) saturate(140%);
//         //   border: 1px solid rgba(255,255,255,0.45);
//         //   box-shadow: 0 12px 28px rgba(16,24,40,0.12), 0 4px 18px rgba(16,24,40,0.06), inset 0 1px 0 rgba(255,255,255,0.40);
//         //   padding: 24px 18px;
//         //   display: flex;
//         //   flex-direction: column;
//         //   align-items: center;
//         //   justify-content: flex-start;
//         // }

//         // /* avatar plate + safe inset so faces never crop */
//         // .tm-avatar-wrap {
//         //   width: 168px;
//         //   height: 168px;
//         //   border-radius: 50%;
//         //   display: grid;
//         //   place-items: center;
//         // //   background: radial-gradient(180px 180px at 50% 40%, #ffffff 0%, #eef4ff 60%, #eaf0ff 100%);
//         // //   box-shadow: 0 10px 24px rgba(49,65,88,.12), inset 0 1px 0 rgba(255,255,255,.65);
//         // }
//         // .tm-avatar {
//         //   width: 142px;
//         //   height: 142px;
//         //   border-radius: 50%;
//         //   object-fit: cover;
//         //   object-position: center 20%;
//         //   display: block;
//         //   border: 2px solid #fff;
//         //   box-shadow: 0 2px 10px rgba(0,0,0,.08);
//         //   background-color: #fff;
//         // }

//         // .tm-name {
//         //   font-size: 20px;
//         //   font-weight: 600;
//         //   color: #1C1C1C;
//         //   margin-top: 14px;
//         //   text-align: center;
//         // }
//         // .tm-role {
//         //   font-size: 16px;
//         //   font-weight: 500;
//         //   color: #6b7280;
//         //   margin-top: 2px;
//         //   text-align: center;
//         // }
//         // .tm-desc {
//         //   font-size: 14px;
//         //   color: #5d6675;
//         //   line-height: 1.45;
//         //   margin-top: 10px;
//         // //   text-align: left;
//         // text-align: center
//         // }

//         // /* Social icons row */
//         // .tm-social {
//         //   margin-top: 16px;
//         //   display: flex;
//         //   gap: 16px;
//         //   justify-content: center;
//         // }
//         // .tm-social-icon {
//         //   width: 28px;
//         //   height: 28px;
//         //   border-radius: 50%;
//         //   background-color: #054E91;
//         //   display: flex;
//         //   align-items: center;
//         //   justify-content: center;
//         //   color: #fff;
//         //   font-size: 18px;
//         //   cursor: pointer;
//         //   transition: transform 0.2s ease;
//         // }
//         // .tm-social-icon:hover { transform: scale(1.1); }

//         // @media (max-width: 576px) {
//         //   .tm-card { height: 420px; }
//         //   .tm-avatar-wrap { width: 150px; height: 150px; }
//         //   .tm-avatar { width: 128px; height: 128px; }
//         //   .tm-viewport { margin-top: 40px; }
//         // }

//         /* ====== cards section ====== */
//     .tm-card{
//   position: relative;
//   flex: 0 0 300px;
//   width: 300px;
//   min-height: 340px;
//   border-radius: 14px;
//   background: #fff;
//   border: 1px solid #E6EEF8;
//   border-top: 4px solid #0A56A2;
//   box-shadow: 0 10px 24px rgba(16,24,40,.08), 0 4px 12px rgba(16,24,40,.05);
//   padding: 28px 22px 24px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: flex-start;
//   overflow: hidden;
//   box-sizing: border-box;
//   transition: transform .2s ease, box-shadow .2s ease;
// }

//       /* Image container: rounded rectangle plate */
//       .tm-avatar-wrap{
//            width: 110px;
//            height: 110px;
//            border-radius: 12px;
//            display: grid;
//            place-items: center;
//            background: #F5FAFF;
//            border: 2px solid #DCEAFB;
//            box-shadow: inset 0 1px 0 rgba(255,255,255,.9);
//        }

//        /* Actual image inside the plate */
//       .tm-avatar{
//           width: 100px;
//           height: 100px;
//           border-radius: 10px;             /* rectangle with small radius */
//           object-fit: cover;
//           object-position: center;
//           display: block;
//           border: 2px solid #ffffff;
//   box-shadow: 0 2px 8px rgba(0,0,0,.06);
//   background: #fff;
// }

// /* Typography like screenshot */
// .tm-name{
//   font-size: 18px;
//   font-weight: 700;
//   color: #0A0F1C;
//   margin-top: 14px;
//   text-align: center;
// }
// .tm-role{
//   font-size: 14px;
//   font-weight: 500;
//   color: #6B7A90;
//   margin-top: 2px;
//   text-align: center;
// }
// .tm-desc{
//   font-size: 14px;
//   color: #5D6675;
//   line-height: 1.45;
//   margin-top: 10px;
//   text-align: center;
//   max-width: 92%;
// }

// .tm-card:hover{
//   transform: translateY(-4px);
//   box-shadow: 0 16px 32px rgba(16,24,40,.10), 0 6px 16px rgba(16,24,40,.06);
// }

// /* Socials keep working; feel free to keep/hide */
// .tm-social{
//   margin-top: 14px;
//   display: flex;
//   gap: 12px;
//   justify-content: center;
// }

// .tm-social-icon{
//   width: 28px; height: 28px; border-radius: 50%;
//   background: #EAF4FF;             /* light blue circle */
//   color: #0A56A2;                   /* dark blue icon */
//   border: 1px solid rgba(10,86,162,.15);
//   display:flex; align-items:center; justify-content:center;
//   font-size: 16px;
//   transition: transform .2s ease, background .2s ease;
// }

// .tm-social-icon:hover{
//   transform: scale(1.08);
//   background: #D9ECFF;              /* halka hover tint */
// }

// /* responsive tweak */
// @media (max-width: 576px){
//   .tm-card{ min-height: 320px; padding: 24px 18px; }
//   .tm-avatar-wrap{ width: 100px; height: 100px; }
//   .tm-avatar{ width: 90px; height: 90px; }
// }

//       `}</style>
//         </>
//     );
// };

// export default Ourteam;

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
//images
import img1 from "../AboutUsPage/images/aanad sir.jpg";
import img2 from "../AboutUsPage/images/sazal sir.jpg";
import img3 from "../AboutUsPage/images/pitamber sir.jpg";
import img4 from "../AboutUsPage/images/kanchan.png";
import img5 from "../AboutUsPage/images/Ravindra Paswan.jpeg";
import img6 from "../AboutUsPage/images/Amit1.jpg";
import img7 from "../AboutUsPage/images/neha.png";
import img8 from "../AboutUsPage/images/Lucky.png";
import img9 from "../AboutUsPage/images/Rojalin.png";

import { FaTwitter, FaLinkedinIn } from "react-icons/fa";

const data = [
  {
    image: img1,
    name: "Shailendra Anand",
    position: "(Founder)",
    desc: "As Founder, spearheading the design of scalable systems to streamline customer data management, enabling high lead conversion and sustained client relationships.",
  },
  {
    image: img2,
    name: "Sazal Malhotra",
    position: "(Co-Founder)",
    desc: "As Co-Founder, driving the vision and development of AI-powered no-code chatbot solutions to transform customer engagement and accelerate business growth.",
  },
  {
    image: img3,
    name: "Pitamber Sarway",
    position: "(Fullstack Developer)",
    desc: "Engineering end-to-end web solutions with seamless frontend, backend, and API integration to strengthen brand trust and maximize user engagement.",
  },
  {
    image: img4,
    name: "Kanchan Adil",
    position: "(Business Analyst)",
    desc: "Analyzing data-driven strategies to maximize customer reach through broadcasting and boost conversions with targeted retargeting insights.",
  },
  {
    image: img5,
    name: "Ravindra Pasvan",
    position: "(Full Stack & Flutter Developer)",
    desc: "Designing responsive user interfaces and integrating backend functionality to deliver seamless digital experiences and measurable business impact.",
  },
  {
    image: img6,
    name: "Amit Banjare",
    position: "(Fullstack Developer)",
    desc: "Developing robust fullstack applications with a strong focus on secure backend architecture, API integration, and compliant data storage.",
  },
  {
    image: img7,
    name: "Neha Nand",
    position: "(Graphics Designer)",
    desc: "Designing impactful visuals and creatives that enhance brand communication, streamline customer interaction, and elevate business presence across platforms.",
  },
  {
    image: img8,
    name: "Lekheshwar Das",
    position: "(Fullstack Developer)",
    desc: "Developing robust frontend and backend systems with efficient API handling to enable large-scale broadcasts and precise customer retargeting.",
  },
  {
    image: img9,
    name: "Rojalin Behera",
    position: "(Frontend Developer)",
    desc: "Creating dynamic user interfaces and integrating backend functionalities to scale customer engagement via broadcast and retargeting.",
  },
];

const Ourteam = () => {
  return (
    <section className="py-4 position-relative" style={{ overflow: "hidden" }}>
      <div
        className="px-3 px-md-4 mx-auto position-relative"
        style={{ maxWidth: "72%", zIndex: 1 }}
      >
        {/* Heading */}
        <div style={{ marginTop: "80px" }}>
          <h2
            style={{
              fontSize: "44px",
              fontFamily: "'Inter', sans-serif",
              fontWeight: 650,
              color: "#1C1C1C",
              lineHeight: 1.2,
            }}
          >
            Our Team
          </h2>
          <p
            className="mt-2"
            style={{
              fontSize: "20px",
              color: "#6B6B6B",
              fontWeight: 400,
              fontFamily: "'Inter', sans-serif",
              lineHeight: 1.2,
            }}
          >
            We are a passionate team of developers, designers, analysts and
            marketers-turning bold ideas into impactful, scalable digital
            solutions that drive growth and shape the future.
          </p>
        </div>

        {/* Auto left-scroll row with added top space */}
        <TeamMarquee items={data} />
      </div>
    </section>
  );
};

const TeamMarquee = ({ items }) => {
  // Fixed card dimensions for consistent animation
  const CARD_W = 300;
  const CARD_GAP = 28;
  const SPEED_SEC = 30; // Slower speed for better viewing

  // Calculate total width of one complete set
  const totalWidth = (CARD_W + CARD_GAP) * items.length - CARD_GAP;

  return (
    <>
      <div className="tm-viewport">
        <div className="tm-track" aria-label="Team members carousel">
          {/* Render original items */}
          {items.map((member, index) => (
            <article key={`original-${index}`} className="tm-card">
              <div className="tm-avatar-wrap">
                <img
                  src={member.image}
                  alt={member.name}
                  className="tm-avatar"
                />
              </div>
              <div className="tm-name">{member.name}</div>
              <div className="tm-role">{member.position}</div>
              <div className="tm-desc">{member.desc}</div>
              {/*  Social icons */}
              <div className="tm-social">
                <div className="tm-social-icon">
                  <FaTwitter />
                </div>
                <div className="tm-social-icon">
                  <FaLinkedinIn />
                </div>
              </div>
            </article>
          ))}

          {/* Render duplicate items for seamless loop */}
          {items.map((member, index) => (
            <article
              key={`duplicate-${index}`}
              className="tm-card"
              aria-hidden="true"
            >
              <div className="tm-avatar-wrap">
                <img
                  src={member.image}
                  alt={member.name}
                  className="tm-avatar"
                />
              </div>
              <div className="tm-name">{member.name}</div>
              <div className="tm-role">{member.position}</div>
              <div className="tm-desc">{member.desc}</div>
              {/* Social icons exactly  */}
              <div className="tm-social">
                <div className="tm-social-icon">
                  <FaTwitter />
                </div>
                <div className="tm-social-icon">
                  <FaLinkedinIn />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      <style>{`
        .tm-viewport {
          position: relative;
          overflow: hidden;
          width: 100%;
          margin-top: 60px; 
          -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
          mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
        }
        
        .tm-track {
          display: flex;
          gap: ${CARD_GAP}px;
          align-items: stretch;
          will-change: transform;
          animation: tm-scroll ${SPEED_SEC}s linear infinite;
        }
        
        .tm-viewport:hover .tm-track { 
          animation-play-state: paused; 
        }

        /* Perfect seamless loop animation */
        @keyframes tm-scroll {
          from { 
            transform: translateX(0); 
          }
          to { 
            transform: translateX(-${totalWidth}px); 
          }
        }

        /* ====== cards section ====== */
    .tm-card{
      position: relative;
      flex: 0 0 300px;
      width: 300px;
      min-height: 360px; /* Increased height */
      border-radius: 14px;
      background: #fff;
      border: 1px solid #E6EEF8;
      border-top: 4px solid #0A56A2;
      box-shadow: 0 10px 24px rgba(16,24,40,.08), 0 4px 12px rgba(16,24,40,.05);
      padding: 28px 22px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      box-sizing: border-box;
      transition: none; 
      cursor: pointer; 
    }

      /* Image container: rounded rectangle plate */
      .tm-avatar-wrap{
           width: 120px;
           height: 120px;
           border-radius: 12px;
           display: grid;
           place-items: center;
           background: #F5FAFF;
           border: 2px solid #DCEAFB;
           box-shadow: inset 0 1px 0 rgba(255,255,255,.9);
        }

        /* Actual image inside the plate */
      .tm-avatar{
          width: 130px;
          height: 130px;
          border-radius: 10px;
          object-fit: contain;
          object-position: center;
          display: block;
          border: 2px solid #ffffff;
          box-shadow: 0 2px 8px rgba(0,0,0,.06);
          background: #fff;
    }

    /* Typography like screenshot */
    .tm-name{
      font-size: 18px;
      font-weight: 700;
      color: #223a58;
      margin-top: 14px;
      text-align: center;
    }
    .tm-role{
      font-size: 14px;
      font-weight: 300;
      color: #394450;
      margin-top: 2px;
      text-align: center;
    }
    .tm-desc{
      font-size: 15px;
      font-weight: 400;
      color: #394450;
      line-height: 1.2;
      margin-top: 4px;
      text-align: center;
      max-width: 92%;
    }

    .tm-social{
      margin-top: 14px;
      display: flex;
      gap: 12px;
      justify-content: center;
    }

    .tm-social-icon{
      width: 28px; height: 28px; border-radius: 50%;
      background: #EAF4FF;
      color: #0A56A2;
      border: 1px solid rgba(10,86,162,.15);
      display:flex; align-items:center; justify-content:center;
      font-size: 16px;
      transition: none; /* Removed transition for hover effect */
      cursor: pointer; /* Changed cursor to pointer */
    } 

    /* Removed hover effects */
    .tm-card:hover {
      transform: none;
      box-shadow: 0 10px 24px rgba(16,24,40,.08), 0 4px 12px rgba(16,24,40,.05);
    }

    .tm-social-icon:hover {
      transform: none;
      background: #EAF4FF;
    }

    /* responsive tweak */
    @media (max-width: 576px){
      .tm-card{ min-height: 340px; padding: 24px 18px; } /* Adjusted for mobile */
      .tm-avatar-wrap{ width: 100px; height: 100px; }
      .tm-avatar{ width: 90px; height: 90px; }
    }
      
    `}</style>
    </>
  );
};

export default Ourteam;
